import { Component, uiElements, uiEvent } from "@kluntje/core";
import { getCurrentMQ } from "@kluntje/js-utils/lib/dom-helpers";
import { LazyImage } from "Components/sde-e-lazy-image/sde-e-lazy-image";
import mediaQueries from "Config/mediaQueries";
import LightboxService from "Services/LightboxService";
export class SDEImageGallery extends Component {
  private imageMap: WeakMap<LazyImage, number> = new WeakMap();

  @uiElements(".sde-m-image-gallery__image")
  private images: Array<LazyImage>;

  protected afterComponentRender() {
    this.initImageMap();
  }

  private initImageMap() {
    this.images.forEach((image, index) => {
      this.imageMap.set(image, index);
    });
  }

  @uiEvent("images", "click")
  protected handleImageCLick(e: MouseEvent) {
    const currentMq = getCurrentMQ(mediaQueries);
    if (currentMq === "MQ1") return;
    const clickedImage = e.currentTarget as LazyImage | null;
    if (clickedImage === null) return;
    const imageIdx = this.imageMap.get(clickedImage);

    LightboxService.open({ activeImageIdx: imageIdx || 0, images: this.images });
  }
}

customElements.define("sde-m-image-gallery", SDEImageGallery);
